import React, { useState, useEffect } from 'react';
import '../../App.css';
import BookingAddOn from '../BookingAddOn';
import { BookingDetails } from '../BookingDetails';
import { BookingHeader } from '../BookingHeader';
import Container from 'react-bootstrap/esm/Container';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { LoadingScreenModal } from '../LoadingScreenModal';
import {
  convertEBticketToCWLticket,
  tokenIsValid,
  getToken,
  sessionStorageGetItem,
} from '../Function';

function BookingHistory() {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  let guid = sessionStorageGetItem('history_guid');
  let addon = sessionStorageGetItem('addon');
  let oldcartguid = sessionStorageGetItem('oldcartguid');

  if (guid != null) {
    guid = JSON.parse(guid);
  }
  if (addon != null) {
    addon = JSON.parse(addon);
  }
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = getToken();
  // console.log(token)
  // const addon = sessionStorageGetItem("addon");
  const reschedule = searchParams.get('reschedule');
  // console.log(reschedule);
  // console.log(addon);
  // console.log(guid);
  const [loading, setLoading] = useState(true);
  const [historyData, setHistoryData] = useState(null);
  useEffect(() => {
    setLoading(true);
    const getHistoryData = async () => {
      try {
        const history_response = await fetch(
          `${SERVER_URL}/me/get/ordersummary/${guid}`,
          {
            method: 'post',
            headers: {
              Authorization: token,
            },
          }
        );
        if (!history_response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${history_response.status}`
          );
        }
        let history_Data = await history_response.text();
        if (history_Data != '') {
          history_Data = JSON.parse(history_Data);
          setHistoryData(history_Data);
          setLoading(false);
        } else {
          getHistoryData();
        }
        // console.log(history_Data)
      } catch (err) {
        setHistoryData(null);
        setLoading(false);
        // console.log("Error")
        // console.log(err.message)
      } finally {
        // setLoading(false)
      }
    };
    tokenIsValid();
    getHistoryData();
  }, [token]);

  // console.log(historyData);
  if (loading)
    return (
      <div className='center'>
        <LoadingScreenModal />
      </div>
    );
  if (historyData != null) {
    var today = new Date();
    var depart_date = new Date(historyData.departtripinfo.departdate);

    // console.log(historyData.details.OrderSummaryHtml);
    // console.log(convertEBticketToCWLticket(historyData.details.OrderSummaryHtml));
    // console.log(convertEBticketToCWLticket(historyData.details.OrderSummaryHtml).search('Server :'));
    // console.log(`depart_date > today = ${depart_date > today}`)

    return (
      <>
        {reschedule === 'true' && (
          <Container style={{ paddingTop: '16px' }}>
            <button
              type='button'
              onClick={() => navigate('/manageBooking')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                background: '#ffffff',
                color: '#003a81',
                border: '1px solid #d9e2ec',
                borderRadius: '8px',
                padding: '8px 16px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              <span className='material-symbols-outlined' style={{ fontSize: '18px' }}>
                arrow_back
              </span>
              Back to Manage Booking
            </button>
          </Container>
        )}
        <BookingHeader
          booking_status='Confirmed'
          printTicket='Re-Print Ticket'
          historyData={historyData}
          trip_id={historyData.ordernumber}
          ticketPDF={historyData.pdffile}
          editBooking={reschedule == 'true' ? true : false}
        />
        <BookingDetails
          historyData={historyData}
          view={
            reschedule === 'true' && depart_date > today && oldcartguid != ''
              ? false
              : true
          }
          addon={addon}
        />
        <BookingAddOn addon={addon} />
      </>
    );
  }
}

export default BookingHistory;
